import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INAAction } from '../../model/ina-action';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-preschool',
  templateUrl: './preschool.component.html',
  styleUrls: ['./preschool.component.scss']
})
export class PreschoolComponent implements OnInit {
  @Input() step: number;
  @Input() action: INAAction;
  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  frmPreSchool: UntypedFormGroup;
  section: Section;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();
  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
    ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.frmPreSchool = this.fb.group({
      radioNonmep: [''],
      where: [''],
      preSchoolComments: [''],

    })
  }

  ngOnInit(): void {


    let sectionId: number = 21;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmPreSchool.dirty) {        
        this.setFormValue();
      }
    });
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });

    if (this.action == INAAction.View) {
      this.frmPreSchool.disable();
    }
    else {
      this.radioNonmep.valueChanges.subscribe((value:any) => {                
        if (value == "1") {
          this.setRadioValue(329, 'Yes', value);
          this.where.enable();
        }
        else if (value == "2") {
          this.setRadioValue(329, 'No', value);
          this.where.disable();
          this.where.setValue('');
        }
        
      })
    }
  }

  setFormValue() {
    this.getQuestionValueDataCheckBox(329, 'Enrolled in a non-MEP preschool?').forEach
      (
        x => {
          if (x.Name == 'Yes' && x.Value == 'True') {
            this.radioNonmep.setValue("1");
            this.where.setValue(this.getQuestionValue(332, 'Where?'));
          }
          else if (x.Name == 'No' && x.Value == 'True') {
            this.radioNonmep.setValue("2");
            this.where.setValue('');
            this.where.disable();
          }

        }
      );


    this.preSchoolComments.setValue(this.getQuestionValue(333, 'Comments'));

  }
  getQuestionValueDataCheckBox(questionId: number, questionName: string): LstQuestionValueDataView[] {
    return this.shared.getListQuestionValueData(this.section, questionId, questionName);
  }

  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }
  /*
  setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }

  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
      let s: StepAction = new StepAction();
      s.stepNumber = 4;
      s.action = action == 1 ? '': this.notifyAction ;
      s.section = new Section();
      if (this.frmPreSchool.dirty) {
        this.updateChangeValue();
        s.section = this.section;
        s.lsttrackingHistory = this.lstTrackHistory;        
        this.lstTrackHistory=[];
      }
      this.prevOrNextStep.emit(s);

  }
      */

  updateChangeValue() {

    if (this.where.dirty) {
      this.setListQuestionValue(332, 'Where?', this.where.value);
    }
    if (this.preSchoolComments.dirty) {
      this.setListQuestionValue(333, 'Comments', this.preSchoolComments.value);
    }    
  }

  setRadioValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }




  get radioNonmep(): any { return this.frmPreSchool.get('radioNonmep') }
  get where(): any { return this.frmPreSchool.get('where') }
  get preSchoolComments(): any { return this.frmPreSchool.get('preSchoolComments') }

}
